import CoreFactory from './core_factory'
export default CoreFactory



// WEBPACK FOOTER //
// ./src/components/core_factory/index.js